module.exports = __webpack_public_path__ + "img/lct.53f16ab9.png";